export type AnalyticsEvent = {
  name: string;
  level: EventLevel;
  props?: Record<string, unknown>;
};

export enum EventLevel {
  INFO = "info",
  ERROR = "error",
}

export interface AnalyticsClient {
  capture(evt: AnalyticsEvent): void | Promise<void>;
}
